
import { Typography } from '@mui/material'
import { Variants, motion } from 'framer-motion'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';


function Project(props: { fullRadius? : true, logo: string, title: string, description: string, link: string, linkName: string, date: string, showBtn?: true }) {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const scroll: Variants = {
        offscreen: {
            y: 15,
            opacity: .5
        },
        onscreen: {
            y: 10,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };

    return (
        <>
            <div className='project' style={{ width: "100%" }} >

                <center>
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: false, amount: 0.8 }}
                        variants={scroll}
                    >
                        <img style={{ borderRadius:(props.fullRadius? "100%" : "20px")}} width={"80%"} height={"200px"} src={props.logo} alt="" />
                    </motion.div>
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: false, amount: 0.8 }}
                        variants={scroll}
                    ><Typography variant='h6'>
                            {props.title}
                        </Typography>
                    </motion.div>
                    <hr />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: false, amount: 0.8 }}
                        variants={scroll}
                    ><label className='descriptionP' style={{ fontWeight: "lighter" }}>
                            {props.description}
                        </label></motion.div>
                    <br /><br />
                    {props.showBtn ?
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                        ><button className="btn" onClick={(event) => {

                            navigate(props.link)
                            const anchor = (
                                (event.target as HTMLDivElement).ownerDocument || document
                            ).querySelector('#back-to-top-anchor');

                            if (anchor) {
                                anchor.scrollIntoView({
                                    block: 'center',
                                });
                            };
                        }}>{t("contenu.texte77")}</button></motion.div>

                        : ""}
                    {/* {t("voir-la-certif")} */}
                    <br />
                </center>
            </div>
            <br />
        </>
    )
}

export default Project
